import request from '@/service/request'
import { ILoginParams,IUpdatePwdParams } from '../model'
enum Api {
  GET_EXPRESS_COMPANY_LIST = '/cooperationRelation/listExpress',
  GET_CUSTOMER_LIST = '/customerManager/page',
  GET_CUSTOMER_DETAIL = '/customerManager/detail',
  FORGET_PWD = '/staff/forgetPwd',
  CHANGE_INIT_PWD = '/staff/changeInitPwd',
  CHANGE_PWD = '/staff/changePwd',
  GET_MESSAGE_LIST = '/msgPush/page',
  SET_HAS_READ = '/msgPush/read',
  GET_LIST_DICT_DATA = 'dict-value/listDictData',
  GET_DICT_VALUE = '/dict-value/getDictValue',
  UPLOAD_FILE = '/architecture/upload',
  SEND_SMS = '/captcha/sendSms'
}

export default class commonService {
  /**
   * 获取快递公司列表
   * @param data
   * @returns
   */
  static getExpressCompanyList(): Promise<any> {
    return request.get(Api.GET_EXPRESS_COMPANY_LIST)
  }

  /**
   * 客户管理列表
   * @param data
   * @returns
   */
  static getCustomerList(data: any): Promise<any> {
    return request.post(Api.GET_CUSTOMER_LIST, data)
  }

  /**
   * 用户信息详情
   * @param data
   * @returns
   */
  static getCustomerDetail(data: any): Promise<any> {
    return request.post(Api.GET_CUSTOMER_DETAIL, data)
  }

  /**
   * 忘记密码
   * @param data
   * @returns
   */
  static forgetPwd(data: ILoginParams): Promise<any> {
    return request.post(Api.FORGET_PWD, data)
  }
  /**
   * 修改初始密码
   * @param data
   * @returns
   */
  static changeInitPwd(data: ILoginParams): Promise<any> {
    return request.post(Api.CHANGE_INIT_PWD, data)
  }

  /**
   * 修改密码
   * @param data
   * @returns
   */
  static changePwd(data: IUpdatePwdParams): Promise<any> {
    return request.post(Api.CHANGE_PWD, data)
  }

  /**
   * 消息中心列表
   * @param data
   * @returns
   */
  static getMessageList(data: any): Promise<any> {
    return request.post(Api.GET_MESSAGE_LIST, data)
  }
  
  /**
   * 将消息设为已读
   * @param data
   * @returns
   */
  static setHasRead(data: any): Promise<any> {
    return request.post(Api.SET_HAS_READ, data)
  }
  
  /**
   * 根据字典type获取字典数据
   * @param data
   * @returns
   */
  static getListDictDataList(data: any): Promise<any> {
    return request.post(Api.GET_LIST_DICT_DATA, data)
  }
  
  /**
   * 获取地址库数据
   * @param data
   * @returns
   */
  static getAddressJson(url:string,data: Record<string, any>): Promise<any> {
    return request.get(url, data)
  }
  
  /**
   * 获取数据字典值
   * @param data
   * @returns
   */
  static getDictValue(data: any): Promise<any> {
    return request.post(Api.GET_DICT_VALUE, data)
  }
 
  /**
   * 文件上传
   * @param data
   * @returns
   */
  static uploadFile(data: any): Promise<any> {
    return request.post(Api.UPLOAD_FILE, data, false,'multipart/form-data')
  }

  /**
   * 邮箱发送短信验证码
   * @param data
   * @returns
   */
  static sendSMS(data: any): Promise<any> {
    return request.post(Api.SEND_SMS, data)
  }
  // 查询订单来源
  static dimSource(data: { param: string }): Promise<any> {
    return request.post('/orderSource/dimSource', data)
  }
  /**
   * 查询订单来源类型
   * @param data
   * @returns
   */
  static querySource(data: Record<string, any>): Promise<any> {
    return request.post('/orderSource/querySource', data)
  }
}
